import { Model } from 'app/model/backendmodel';
import { ActivityAsyncAdapter } from './activity.adapter';

import { IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import _ from 'lodash';
import { Activity } from 'app/model/pipeline/activity';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(Activity),
    asynchronous: true
})
export class GenericActivityAdapter extends ActivityAsyncAdapter<Activity, Model.Activity> {

    public model(): IModel {
        return Metamodel.modelFor(Activity);
    }

    protected async _toResource(activity: Activity): Promise<Model.Activity> {
        const modelActivity: Model.Activity = super._getCommonActivityProperties(activity, Metamodel.modelOf(activity).name);
        if (activity.raw) {
            const parsed = JSON.parse(activity.raw);
            // Overlay this on spark activity
            _.merge(modelActivity, parsed);
        }
        return modelActivity;
    }

    protected async _toModel(modelActivity: Model.Activity): Promise<Activity> {
        const metaModel = Metamodel.modelByName(modelActivity.type);
        const activity = metaModel.create<Activity>(modelActivity.name);
        this._updatedCommonProperties(modelActivity, activity);

        activity.raw = JSON.stringify(await ValueAdapter.remainder(this.context, modelActivity, metaModel));
        return activity;
    }
}
